export default __webpack_public_path__ + "static/media/LOGI-TECH-IMG.428608c2.gif";